/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Wundo_HereInputs */



/**
* | output |
* | --- |
* | "Wundo at this conversation" |
*
* @param {Meeting_Wundo_HereInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_wundo_here = /** @type {((inputs?: Meeting_Wundo_HereInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Wundo_HereInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo bij dit gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo dans cette conversation")
	return /** @type {LocalizedString} */ ("Wundo at this conversation")
});